import React, { useState } from "react";
import { AxiosError } from "axios";
import moment from "moment-timezone";

import { CourseDto, ICourseSummary } from "@eagerdog/interfaces";
import { Constants } from "@eagerdog/constants";

import { toast } from "src/components/Toast/ToastManager";
import Button from "src/components/Button/Button";
import { apiService } from "src/services/api.service";
import Dropdown, { IOption } from "../Dropdown/Dropdown";
import DatePick from "../DatePick/DatePick";
import date from "../../assets/icons/date.svg";

import "../PublishEventModal/PublishEventModal.scss";

interface IProps {
  toggle: () => void,
  afterUpdate?: () => void,
  course?: ICourseSummary
}

const PublishCourseModal: React.FC<IProps> = (props) => {
  const [publishOption, setPublishOption] = useState<IOption>(
    { value: "Immediately", id: "Immediately" }
  );

  const [publishDate, setPublishDate] = useState(
    new Date(Date.now() + 3600 * 1000 * 24)
  );

  const timezone = props.course?.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone;

  return (
    <div className="Confirm">
      <div>
        <div className="title">Publish Course</div>
        <p>When do you want entries to open for this course?</p>
        <Dropdown value={publishOption} onChange={(e: any, value: IOption) => { setPublishOption(value); }} icon={date} label="Entry Open Date" options={[ { value: "Immediately", id: "Immediately" }, { value: "On a Specific Date", id: "On a Specific Date" } ]} placeholder="Choose a publishing option" />
        <>
          {publishOption.value === "On a Specific Date" && (<DatePick showTimeSelect={true} label="Publish Date" onChange={setPublishDate} value={publishDate} rightText={props.course?.timezone ? timezone : Intl.DateTimeFormat().resolvedOptions().timeZone}/>)}
        </>
      </div>
      <div className="button-group">
        <Button onClick={() => {
          props.toggle()
        }}>Cancel</Button>
        <Button
          onClick={() => {
            if (props.course) {
              const publishAt = publishOption.value === "Immediately"
                ? new Date()
                : moment.tz(moment(publishDate).format("YYYY-MM-DD HH:mm"), timezone).toISOString();

              const courseFields = { ...(props.course as ICourseSummary & Record<string, unknown>) };
              [
                "__v",
                "_id",
                "club",
                "documents",
                "created_at",
                "updated_at",
                "created_by",
                "updated_by",
              ].forEach((key) => {
                delete courseFields[key];
              });

              const payload = {
                ...courseFields,
                publish_at: publishAt,
                status: publishOption.value === "Immediately" ? Constants.course_status.published : Constants.course_status.upcoming,
              }

              apiService.updateCourse(props.course._id, payload as CourseDto).then((response) => {
                if (response._id) {
                  props.toggle()
                  if (props.afterUpdate) {
                    props.afterUpdate()
                  }
                  toast.show({
                    title: "Update Course",
                    content: "You've successfully updated your course",
                    duration: 10000,
                    type: "success"
                  });
                }
              }).catch((e: AxiosError) => {
                toast.show({
                  title: "Publish Course",
                  content: "Unable to publish course",
                  duration: 10000,
                  errorDetails: e,
                  type: "fail",
                });
              });
            }
          }}
        >
          Publish now
        </Button>
      </div>
    </div>
  );
}

export default PublishCourseModal;
